

import { AgentDefaultRatesPage } from '../agent-default-rates-page'
import template from './agent-default-rates-modal-component.html'
import ko from 'knockout';
import { Observable, ObservableArray } from 'knockout'; 
import dataModel from 'data-model';

class AgentDefaultRatesModal {
    $parent: AgentDefaultRatesPage;
    gridrowdata: AgencyDefaultRateGridData;
    defaultPayMethodId : Observable<any> = ko.observable();
    defaultLoadedPayRate: Observable<number> = ko.observable();
    defaultEmptyPayRate: Observable<number> = ko.observable();
    selectedAgencyId: number;
    agencyEarnDeductDefaultRecords: ObservableArray<AgencyEarnDeductDefaultRecord> = ko.observableArray([]);
    filterAlreadyExistingDeductionCodesSwitch = false;
    showLoadingPanel: Observable<boolean> = ko.observable(false);

    constructor(data) {
        this.$parent = data.parent;
        this.gridrowdata = data.data;
        this.initializeComponents();
        this.getAgencyEarnDeductDefaultRecords();
    }

    initializeComponents() {
        this.selectedAgencyId = this.gridrowdata.id;
        this.defaultPayMethodId(this.gridrowdata.defaultPayMethodId || 4);
        this.defaultLoadedPayRate(this.gridrowdata.defaultLoadedPayRate || 75.00);
        this.defaultEmptyPayRate(this.gridrowdata.defaultEmptyPayRate || 0);
    }

    getAgencyEarnDeductDefaultRecords() {
        dataModel.ajaxRequest("CustomPaySolutions/GetAgencyEarnDeductDefaultRecords", "get", {selectedAgencyId: this.selectedAgencyId})
        .done((v) => {
            this.agencyEarnDeductDefaultRecords(v.map((x) => new AgencyEarnDeductDefaultRecord(x)))
            setTimeout(() => {
                this.filterAlreadyExistingDeductionCodesSwitch = true;
            }, 1000)
        })
    }

    filterAlreadyExistingDeductionCodes = (data) => {
        if(data.length > 1 && this.filterAlreadyExistingDeductionCodesSwitch == true) {
            data = data.filter(resp => {
                let doesElementExist = this.agencyEarnDeductDefaultRecords().some(existing => {
                    return resp.id == existing.deductEarningId;
                })
                return !doesElementExist;
            })
        }
        return data;
    }

    deleteRecord = (data) => {
        this.agencyEarnDeductDefaultRecords.remove(data)
    }

    addDefaultPayRate() {
        this.agencyEarnDeductDefaultRecords.push(new AgencyEarnDeductDefaultRecord())
    }

    saveAgentDefaultRates = () => {
        let payload = {
            selectedId: this.selectedAgencyId,
            defaultEmptyPayRate: this.defaultEmptyPayRate(),
            defaultLoadedPayRate: this.defaultLoadedPayRate(),
            defaultPayMethodId: this.defaultPayMethodId() ? this.defaultPayMethodId().value : undefined,
            agencyEarnDeductDefaultDTOs: this.agencyEarnDeductDefaultRecords()
                .map((x) => x.obj).filter((x) => x.deductEarningId)
        }

        this.showLoadingPanel(true);
        dataModel.ajaxRequest("CustomPaySolutions/SaveAgencyEarnDeductDefaultRecords", "post", payload)
        .done((x) => {
            this.$parent.agentDefaultRatesGrid.grid.updatebounddata('data');
            $('#closeButton').trigger("click");
        }).always((x) => {
            this.showLoadingPanel(false);
        })
    }
}

class AgencyEarnDeductDefaultRecord {
    id: number;
    defaultPct: Observable<number>;
    deductEarningId: number;
    externalID: string;
    deductionCodeInput: Observable<any>;
    description: Observable<string>;
    constructor(x?) {
        x = x || {};
        this.id = x.id;
        this.deductEarningId = x.deductEarningId;
        this.externalID = x.externalID;
        this.description = ko.observable(x.description);
        this.defaultPct = ko.observable(x.defaultPct || 0);
        this.deductionCodeInput = ko.observable(x.externalID);
    }
    onDeductionCodeSelected = (v) => {
        if(v) {
            this.deductEarningId = v.id;
            this.description(v.description);
            this.externalID = v.code
            if(v.code.toUpperCase() == "FSC") {
                this.defaultPct(100);
            }
        }
    }
    get obj() {
        return {
            deductEarningId : this.deductEarningId,
            defaultPct: this.defaultPct
        }
    }
}

class AgencyDefaultRateGridData {
    id: number;
    externalID: string;
    name: string;
    isActive: string;
    customPay: boolean;
    contractDate: Date;
    terminationDate: Date;
    defaultPayMethodId: number;
    defaultLoadedPayRate: number;
    defaultEmptyPayRate: number;
}

export default { template: template, viewModel: AgentDefaultRatesModal }
export { AgentDefaultRatesModal }